"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProductShadesQuery = void 0;
var _tsUtils = require("@ori/ts-utils");
var _mapShadeWithPrice = require("./mapShadeWithPrice");
const mapSearchPreviewShades = shades => shades?.filter(_tsUtils.isNonNullable).map(_mapShadeWithPrice.mapShadeWithPrice) ?? [];
const mapProductShadesQuery = query => {
  const {
    concept,
    pdpUrl
  } = query.product ?? {};
  return {
    goToUrl: pdpUrl?.relativeUrl ?? '',
    productName: concept?.name ?? '',
    products: mapSearchPreviewShades(query.product?.concept?.products)
  };
};
exports.mapProductShadesQuery = mapProductShadesQuery;
//# sourceMappingURL=mapProductShadesQuery.js.map